import { useState } from 'react'
import { supabase } from '../supabaseClient'
import { localDateString } from '../utils/date'

const BEHAVIORS = [
  { id: 'alcohol', label: 'Alcohol' },
  { id: 'drugs', label: 'Drugs' },
  { id: 'porn', label: 'Porn' },
  { id: 'smoking', label: 'Smoking' },
  { id: 'gambling', label: 'Gambling' },
  { id: 'nails', label: 'Nail Biting' },
  { id: 'social_media', label: 'Social Media' },
  { id: 'skin_picking', label: 'Skin Picking' },
]

export default function Onboarding({ session, onComplete }) {
  const [step, setStep] = useState(1)
  const [username, setUsername] = useState('')
  const [selected, setSelected] = useState(null)
  const [loading, setLoading] = useState(false)

  async function handleStart() {
    if (!selected) return
    setLoading(true)

    const today = localDateString()

    await supabase.from('profiles').upsert({
      id: session.user.id,
      username: username.trim(),
      behavior: selected,
    })

    await supabase.from('streaks').insert({
      user_id: session.user.id,
      behavior: selected,
      start_date: today,
      days_count: 0,
      is_active: true,
    })

    onComplete()
  }

  if (step === 1) {
    return (
      <div style={styles.container}>
        <div style={styles.inner}>
          <div style={{ textAlign: 'center', marginBottom: 48 }}>
            <div style={{ fontSize: 48 }}>⚓</div>
            <h1 style={styles.title}>What should we call you?</h1>
            <p style={styles.sub}>Just a first name is fine.</p>
          </div>

          <input
            style={styles.input}
            placeholder="Your name"
            value={username}
            onChange={e => setUsername(e.target.value)}
            onKeyDown={e => { if (e.key === 'Enter' && username.trim()) setStep(2) }}
            autoFocus
          />

          <button
            onClick={() => setStep(2)}
            disabled={!username.trim()}
            style={{
              ...styles.mainBtn,
              opacity: username.trim() ? 1 : 0.4,
            }}
          >
            Continue →
          </button>
        </div>
      </div>
    )
  }

  return (
    <div style={styles.container}>
      <div style={styles.inner}>
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <div style={{ fontSize: 48 }}>⚓</div>
          <h1 style={styles.title}>What are you working on?</h1>
          <p style={styles.sub}>No judgment. Every struggle is valid.</p>
        </div>

        <div style={styles.grid}>
          {BEHAVIORS.map(b => (
            <button
              key={b.id}
              onClick={() => setSelected(b.id)}
              style={{
                ...styles.btn,
                border: selected === b.id
                  ? '2px solid #7c3aed'
                  : '2px solid rgba(255,255,255,0.08)',
                background: selected === b.id
                  ? 'rgba(124,58,237,0.15)'
                  : 'rgba(255,255,255,0.04)',
              }}
            >
              <span style={styles.btnLabel}>{b.label}</span>
            </button>
          ))}
        </div>

        <button
          onClick={handleStart}
          disabled={!selected || loading}
          style={{
            ...styles.mainBtn,
            opacity: selected ? 1 : 0.4,
          }}
        >
          {loading ? 'Setting up...' : 'Start my recovery →'}
        </button>
      </div>
    </div>
  )
}

const styles = {
  container: {
    minHeight: '100vh',
    background: '#080812',
    display: 'flex',
    justifyContent: 'center',
    padding: '40px 20px',
  },
  inner: {
    width: '100%',
    maxWidth: 400,
  },
  title: {
    color: '#fff',
    fontFamily: 'serif',
    fontSize: 26,
    margin: '8px 0 4px',
  },
  sub: {
    color: 'rgba(255,255,255,0.4)',
    fontSize: 14,
    margin: 0,
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 12,
    marginBottom: 32,
  },
  btn: {
    padding: '20px 12px',
    borderRadius: 16,
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 8,
  },
  btnLabel: {
    color: '#fff',
    fontSize: 13,
    fontWeight: 600,
  },
  input: {
    width: '100%',
    padding: '16px 18px',
    background: 'rgba(255,255,255,0.06)',
    border: '1px solid rgba(255,255,255,0.12)',
    borderRadius: 14,
    color: '#fff',
    fontSize: 16,
    outline: 'none',
    marginBottom: 16,
  },
  mainBtn: {
    width: '100%',
    padding: 16,
    background: 'linear-gradient(135deg, #7c3aed, #2563eb)',
    border: 'none',
    borderRadius: 14,
    color: '#fff',
    fontSize: 16,
    fontWeight: 700,
    cursor: 'pointer',
  },
}